import React from 'react'
import { ExternalComponentRuntimeError } from '@wix/external-component-renderer'

type Props = {
	onError: Function
	children: React.ReactNode
}

type State = {
	hasError: boolean
}

class ErrorBoundary extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props)
		this.state = { hasError: false }
	}

	static getDerivedStateFromError(error: Error) {
		return { hasError: true, error }
	}

	componentDidCatch(error: Error) {
		const renderError = new ExternalComponentRuntimeError(`Error while rendering. ${error.name}: ${error.message}`)
		this.props.onError(renderError)
	}

	render() {
		if (this.state.hasError) {
			// This is only a placeholder as the error message handling should be on Editor Elements
			// by triggering this.props.onError on componentDidCatch
			return <></>
		}

		return this.props.children
	}
}

export default ErrorBoundary
